/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SmartSmsRequestPeriodicPatterns {
  DaysOfWeek = 0,
  OddDaysOfWeek = 1,
  EvenDaysOfWeek = 2,
  LastTwoDaysOfWeek = 3,
  FirstTwoDaysOfMonth = 4,
  LastTwoDaysOfMonth = 5,
  Custom = 6
}
